var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapitalRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_6476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 7,
    height: 30,
    rx: 2,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 20.8V11C41 9.89543 40.1046 9 39 9H36C34.8954 9 34 9.89543 34 11V20.8",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32C35.843 32 34.5 32.895 34.5 34C34.5 35.105 35.843 36 37.5 36C39.157 36 40.5 36.895 40.5 38C40.5 39.105 39.157 40 37.5 40M37.5 32C38.61 32 39.58 32.402 40.099 33M37.5 32V31M37.5 40C36.39 40 35.42 39.598 34.901 39M37.5 40V41M46.5 36C46.5 37.1819 46.2672 38.3522 45.8149 39.4442C45.3626 40.5361 44.6997 41.5282 43.864 42.364C43.0282 43.1997 42.0361 43.8626 40.9442 44.3149C39.8522 44.7672 38.6819 45 37.5 45C36.3181 45 35.1478 44.7672 34.0558 44.3149C32.9639 43.8626 31.9718 43.1997 31.136 42.364C30.3003 41.5282 29.6374 40.5361 29.1851 39.4442C28.7328 38.3522 28.5 37.1819 28.5 36C28.5 33.6131 29.4482 31.3239 31.136 29.636C32.8239 27.9482 35.1131 27 37.5 27C39.8869 27 42.1761 27.9482 43.864 29.636C45.5518 31.3239 46.5 33.6131 46.5 36Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 16.5,
    x2: 1.5,
    y2: 31.5,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.5,
    y1: 16.5,
    x2: 46.5,
    y2: 23.5,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 24,
    x2: 27.5,
    y2: 24,
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_6476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalRatio);
export default __webpack_public_path__ + "static/media/capitalRatio.5b4f1edb0d3178816963a137af22ecd2.svg";
export { ForwardRef as ReactComponent };